import { Component, Input, OnInit, EventEmitter, Output,SimpleChanges,OnChanges } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { typeOfNullifyCN,  typeOfNullifyDNInterests, typeOfNullifyCNForDN } from "src/app/models/Dte/TypeOfNullify.enum";

@Component({
    selector: 'app-nota-tipo-correccion',
    templateUrl: './nota-tipo-correccion.component.html',
    styleUrls: ['./nota-tipo-correccion.component.scss']
})
export class NotaTipoCorreccionComponent implements OnInit,OnChanges {
    @Input() motivoSeleccionado: string;
    @Input() codigoTipoDte: number;
    @Input() notaForm: FormGroup;
    @Output() motivoSeleccionadoChange = new EventEmitter<string>();
    public typeOfNullify = typeOfNullifyCN;
	public typeOfNullifyDNInterests = typeOfNullifyDNInterests;
    
    public typeOfNullifyCNForDN = typeOfNullifyCNForDN;
    @Output() tipoNotaSeleccionado = new EventEmitter<number>();

    public motivos = ["Error de digitación", "Reclamo de Cliente", "Otros"];
    public interestsMotive = ["Intereses por mora", "Intereses por cambio de fecha", "Otros"];
    public motivosCorrigeTextos = ["Error de digitación", "Datos desactualizados", "Otros"];
    public motivosCorrigeMontos = ["Corrección Monto"];
    @Input() tipoNota: number | null = null;
    selectedTipoNota: string;

    ngOnInit() {
        
        /*if (this.codigoTipoDte === 61) {
            this.selectedTipoNota = typeOfNullifyCN[0]; 
        } else if (this.codigoTipoDte === 56) {
            this.selectedTipoNota = typeOfNullifyDNInterests[0]; 
        }
        this.onChangeTipoNota(this.selectedTipoNota);*/
    }
     ngOnChanges(changes: SimpleChanges) {
        if (changes.tipoNota && changes.tipoNota.currentValue !== undefined && changes.tipoNota.currentValue !== null) {
            const nuevo = changes.tipoNota.currentValue as number;
            const tipoString = this.mapTipoNotaToString(nuevo);
            if (tipoString) {
                this.selectedTipoNota = tipoString;
                this.notaForm?.get('motivo')?.setValue(null);
            }
        }
        if (changes.motivoSeleccionado && changes.motivoSeleccionado.currentValue !== undefined) {
            const motivo = changes.motivoSeleccionado.currentValue as string;
            if (this.notaForm) {
                this.notaForm.get('motivo')?.setValue(motivo, { emitEvent: false });
            }
        }
    }
    private mapTipoNotaToString(tipo: number): string | null {
        if (this.codigoTipoDte === 61) {
            if (tipo === 0) return typeOfNullifyCN[0];
            if (tipo === 1) return typeOfNullifyCN[1];
            if (tipo === 2) return typeOfNullifyCN[2];
        } else if (this.codigoTipoDte === 56) {
            if (tipo === 0) return typeOfNullifyDNInterests[0];
            if (tipo === 1) return typeOfNullifyCNForDN[0];
        }
        return null;
    }

    get motivosParaMostrar(): string[] {
        if (this.codigoTipoDte === 61) {
            if (this.selectedTipoNota === typeOfNullifyCN[0]) {
                return this.motivos;
            } else if (this.selectedTipoNota === typeOfNullifyCN[1]) {
                return this.motivosCorrigeMontos;
            } else if (this.selectedTipoNota === typeOfNullifyCN[2]) {
                return this.motivosCorrigeTextos;
            } else {
                return [];
            }
        } else if (this.codigoTipoDte === 56) {
            if (this.selectedTipoNota === typeOfNullifyDNInterests[0]) {
                return this.interestsMotive;
            }else if (this.selectedTipoNota === typeOfNullifyCNForDN[0]) {
                return this.motivos; 
            }
            else {
                return [];
            }
        }
        return [];
    }

    get isSingleMotivo(): boolean {
        return this.motivosParaMostrar.length === 1;
    }
    mostrarTipoNota(tipo: string): boolean {
        if (this.codigoTipoDte === 61) {
            return Object.values(this.typeOfNullify).includes(tipo);
        } else if (this.codigoTipoDte === 56) {
            return Object.values(this.typeOfNullifyDNInterests).includes(tipo);
        }
        return false;
    }
    onChangeTipoNota(tipo: string) {
        this.selectedTipoNota = tipo;
        this.notaForm.get('motivo').setValue(null);
    

        let tipoNota: number;
        if (this.codigoTipoDte === 61) { 
            if (tipo === typeOfNullifyCN[0]) {
                tipoNota = 0; 
            } else if (tipo === typeOfNullifyCN[1]) {
                tipoNota = 1; 
            } else if (tipo === typeOfNullifyCN[2]) {
                tipoNota = 2; 
            } else {
                tipoNota = -1;
            }
        } else if (this.codigoTipoDte === 56) { 
            if (tipo === typeOfNullifyDNInterests[0]) {
                tipoNota = 0; 
            }else if (tipo === typeOfNullifyCNForDN[0]) { 
                tipoNota = 1; 
            }
            else {
                tipoNota = -1;
            }
        }

        this.tipoNotaSeleccionado.emit(tipoNota);
        const motivos = this.motivosParaMostrar;
        if (motivos.length === 1 ) {
            this.onChangeMotivo(motivos[0]);
        }
    }

    onChangeMotivo(motivo: string) {
        this.motivoSeleccionado = motivo;
        this.notaForm.get('motivo').setValue(motivo);
        this.motivoSeleccionadoChange.emit(motivo);
       
    }
}
